/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  DetailDropdowns,
  DetailDropdownsFromJSON,
  DetailDropdownsFromJSONTyped,
  DetailDropdownsToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface DetailDropdownsControllerResponse
 */
export interface DetailDropdownsControllerResponse {
  /**
   *
   * @type {DetailDropdowns}
   * @memberof DetailDropdownsControllerResponse
   */
  data?: DetailDropdowns;
  /**
   *
   * @type {ErrorResponse}
   * @memberof DetailDropdownsControllerResponse
   */
  error?: ErrorResponse;
}

export function DetailDropdownsControllerResponseFromJSON(json: any): DetailDropdownsControllerResponse {
  return DetailDropdownsControllerResponseFromJSONTyped(json, false);
}

export function DetailDropdownsControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DetailDropdownsControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : DetailDropdownsFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function DetailDropdownsControllerResponseToJSON(value?: DetailDropdownsControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: DetailDropdownsToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
